import React from "react"

function PlayButtonSVG() {
  return (
    <svg width="145" height="139" viewBox="0 0 145 139" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="72.3193" cy="69.1791" rx="72.3193" ry="69.1791" fill="#00681F"/>
      <path d="M50.5665 102.384L110.188 70.9528L50.5665 39.5219L50.5665 102.384Z" fill="white" stroke="#D9D9D9"/>
    </svg>
  )
}

export { PlayButtonSVG }